import { QuestionBaseModel } from './question-base.model';
import { SummerAppFieldTypesEnum } from 'app/shared/enums/field-types.enum';

export class TextboxQuestionModel extends QuestionBaseModel<any> {
    
    type: string;

    constructor(options: {} = {}) {
      super(options);
      switch (options['fieldTypeName']) {
          case SummerAppFieldTypesEnum.Input:
              this.type='text';
              break;
        case SummerAppFieldTypesEnum.Numeric:
              this.type='numeric';
              break;
        case SummerAppFieldTypesEnum.Date:
              this.type='date';        
              this.value=this.value?new Date(this.formatToISODateString(this.value)):null
              break;
          default: 
              break;
      }
    }

    private formatToISODateString(string:string){
        if(string.indexOf('T')<0)
            string=string.replace(' ','T');
        if(string.indexOf('Z')<0)
            string+='Z';
            var date = new Date(string);
            date.setTime(date.getTime()+date.getTimezoneOffset()*60000);
        return date;
    }
  }


// WEBPACK FOOTER //
// ./src/app/shared/models/textbox-question.mode.ts